@if (stimulusView$().length > 1) {
  <swiper [config]="swiperConfig" class="stimulus__carousel">
    @for (media of stimulusView$(); track media.mediaId) {
      <ng-template swiperSlide>
        <div class="stimulus-media-content">
          @if (expandable()) {
            <button mat-icon-button title="Expand" class="stimulus-expand__btn" (click)="expandedMedia$.set(media)">
              <fa-icon [icon]="faUpRightAndDownLeftFromCenter" size="xs"></fa-icon>
            </button>
          }

          <empathy-media-view [media]="media" [url]="media.url" [autoplay]="autoplay() && $first"></empathy-media-view>
        </div>
      </ng-template>
    }
  </swiper>
} @else if (stimulusView$().length === 1) {
  <div class="stimulus-media-content single" [ngClass]="singleImageSize()">
    @if (expandable()) {
      <button mat-icon-button title="Expand" class="stimulus-expand__btn" (click)="expandedMedia$.set(stimulusView$()[0])">
        <fa-icon [icon]="faUpRightAndDownLeftFromCenter" size="xs"></fa-icon>
      </button>
    }

    <empathy-media-view [media]="stimulusView$()[0]" [url]="stimulusView$()[0].url" [autoplay]="autoplay()"></empathy-media-view>
  </div>
}

@if (expandedMedia$(); as expandedMedia) {
  <div class="stimulus-expanded__container">
    <div class="stimulus-expanded__media">
      <div class="stimulus-expanded__media-content">
        <button mat-icon-button title="Close expanded media" (click)="expandedMedia$.set(null)">
          <fa-icon [icon]="faClose"></fa-icon>
        </button>

        <empathy-media-view [media]="expandedMedia" [isExpanded]="true"></empathy-media-view>
      </div>
    </div>
  </div>
}

@if (mediaRequiresCompletion$()) {
  <div class="stimulus-info-banner">
    <fa-icon [icon]="faInfoCircle"></fa-icon>
    @if (stimulusView$().length === 1) {
      <div class="fs__sm fw__600">Please finish this media before you can continue.</div>
    } @else {
      <div class="fs__sm fw__600">Please finish all media before you can continue.</div>
    }
  </div>
}
